<template>
  <v-container class="pt-0">
    <v-form ref="form" v-model="valid">
      <v-card elevation="0" class="d-flex justify-center">
        <v-card-title>Application Form</v-card-title>
      </v-card>
      <v-row justify="center">
        <v-col cols="12" md="4" sm="6" class="text-center pb-0">
          <label class="form-label">
            Application ID <span class="error--text">* </span>
          </label>
          <v-text-field
            v-model="form.application_id"
            outlined
            dense
            :rules="[rules.required, rules.applicationNumber]"
            required
            hide-details="auto"
            @input="form.application_id = form.application_id.toUpperCase()"
            maxlength="15"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="6" class="text-center pb-0">
          <label class="form-label"
            >Date of Birth <span class="error--text">* </span></label
          >
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            max-width="290"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formattedDob"
                dense
                outlined
                readonly
                placeholder="dd-mm-yyyy"
                :rules="[rules.required]"
                v-bind="attrs"
                v-on="on"
                hide-details="auto"
              />
            </template>
            <v-date-picker
              v-model="form.dob"
              @input="menu = false"
              no-title
              scrollable
              ref="dobPicker"
              :max="sixteenYearsAgo"
              :min="hundredYearsAgo"
            />
          </v-menu>
        </v-col>
        <!-- <v-col v-if="form.has_deb_id === 'true'" cols="12" md="4" sm="6" class="text-center pb-0">
          <label class="form-label">
            DEB ID <span class="error--text">* </span>
          </label>
          <v-text-field
            v-model="form.deb_id"
            outlined
            dense
            maxlength="12"
            :rules="[rules.required, rules.number, rules.debId]"
            hide-details="auto"
          ></v-text-field>
        </v-col> -->

        <v-col cols="12" md="8" class="text-center font-weight-medium pb-0">
          Don't have a DEB ID? Click Here
        </v-col>
        <v-col cols="12" md="8" class="text-center pt-0">
          <a target="_blank" href="https://deb.ugc.ac.in/StudentDEBId">
            https://deb.ugc.ac.in/StudentDEBId
          </a>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="d-flex justify-center align-center">
          <v-btn
            v-if="form.student_entry !== ''"
            :disabled="!valid"
            color="success"
            :loading="loading"
            @click="proceedToCheck()"
            >Proceed</v-btn
          >
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="8" class="text-caption text-center pt-0">
          Not yet registered?<a @click="registrationPage()"> Click here </a>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="showApplicantMessage" max-width="500">
      <v-card>
        <v-card-title class="headline primary--text">
          <v-icon color="primary" class="mr-3">mdi-file-clock</v-icon>
          {{ showApplicantMessageHeader }}
        </v-card-title>
        <v-card-text>
          <p v-html="formattedApplicantMessage"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mt-n3"
            text
            @click="(showApplicantMessage = false), resetValues"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="proceedDialog" persistent max-width="520">
      <v-form ref="debValidate" v-model="debValid">
        <v-card class="pa-3 rounded-lg">
          <!-- Dialog Title -->
          <v-card-title class="primary--text font-weight-bold">
            DEB ID
          </v-card-title>

          <v-divider class="mx-3"></v-divider>

          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12" class="d-flex justify-center">
                <v-radio-group
                  v-model="form.has_deb_id"
                  row
                  dense
                  hide-details="auto"
                  class="d-flex justify-center flex-col"
                >
                  <v-radio
                    label="I have a DEB ID"
                    value="true"
                    color="primary"
                  ></v-radio>
                  <v-radio
                    label="I don't have a DEB ID"
                    value="false"
                    color="error"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col
                cols="12"
                md="6"
                ref="debId"
                v-if="form.has_deb_id === 'true'"
                class="text-center"
              >
                <v-text-field
                  v-model="form.deb_id"
                  outlined
                  dense
                  maxlength="12"
                  :rules="[rules.required, rules.number, rules.debId]"
                  hide-details="auto"
                  placeholder="Enter your DEB ID"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                class="text-center error--text mt-2"
                v-if="form.has_deb_id === 'false'"
              >
                Note: A valid DEB ID is mandatory for the final approval.
              </v-col>
            </v-row>
            <div
              v-if="form.has_deb_id === 'false'"
              class="d-flex align-center justify-center mt-6"
            >
              <v-checkbox
                v-model="form.agree"
                class="ma-0 pa-0 mr-2 my-2"
                :rules="[rules.required]"
                hide-details
              ></v-checkbox>
              <span>I agree to the above note.</span>
            </div>
          </v-card-text>

          <!-- Dialog Actions -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="proceedDialog = false">
              Close
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!debValid"
              depressed
              @click="proceed"
            >
              Proceed
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="confirmationDialog" width="500" persistent>
      <confirmationDialogForm
        v-if="confirmationDialog"
        :confirmationText="confirmationText"
        @closeDialog="confirmationDialog = false"
        @saveDialog="approveUnIdentifiedDebApplicant"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { rules } from "@/helpers/rules";
import confirmationDialogForm from "../components/confirmationDialog.vue";
import paymentOptions from "./paymentOptions.vue";
export default {
  components: { confirmationDialogForm, paymentOptions },
  data() {
    return {
      rules,
      valid: false,
      menu: false,
      form: {
        has_deb_id: "true",
        agree: false,
        application_id: "",
        deb_id: "",
        dob: "",
      },
      showApplicantMessage: false,
      showApplicantMessageData: "",
      showApplicantMessageHeader: "",
      confirmationDialog: false,
      confirmationText: "",
      loading: false,
      applicantData: null,
      proceedDialog: false,
      debValid: false,
    };
  },
  computed: {
    formattedDob() {
      if (!this.form.dob) return ""; // If date is not selected yet, show empty
      const [year, month, day] = this.form.dob.split("-");
      return `${day}-${month}-${year}`; // Convert to dd-mm-yyyy
    },
    sixteenYearsAgo() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 16);
      date.setMonth(11);
      date.setDate(31);
      return date.toISOString().substr(0, 10);
    },
    hundredYearsAgo() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 100);
      date.setMonth(0);
      date.setDate(1);
      return date.toISOString().substr(0, 10);
    },
    formattedApplicantMessage() {
      return this.showApplicantMessageData.replace(/\n/g, "<br>");
    },
  },
  watch: {
    menu(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.dobPicker) {
            this.$refs.dobPicker.activePicker = "YEAR";
          }
        });
      }
    },
  },
  async created() {
    localStorage.clear();
    const { application_id, dob, deb_id } = this.$route.query;

    this.form.dob = dob;
    this.form = {
      ...this.form,
      application_id: application_id || this.form.application_id,
      dob: this.formattedDob || this.form.dob,
      deb_id: deb_id || this.form.deb_id,
    };
  },
  methods: {
    async proceedToCheck() {
      const response = await this.$axios.get(
        `/get_applicant_detail?application_id=${this.form.application_id}`,
      );
      const data = response.data.data;
      this.form.deb_id = data.deb_id;

      if (await this.isAdmissionClosed(data.batch_partner_schedule_id)) return;

      if (data.step >= 1 || data.deb_id != null) {
        this.proceedDialog = false;
        this.getApplicantDetail();
      } else {
        this.proceedDialog = true;
      }
    },
    async isAdmissionClosed(scheduleId) {
      if (!scheduleId) return false;
      try {
        const res = await this.$axios.get(
          `batch_partner_schedules/${scheduleId}`,
        );
        const schedule = res.data.data;
        if (!schedule.admission_end_date) return false;

        const [yyyy, mm, dd] = schedule.admission_end_date
          .split("-")
          .map(Number);
        const endDateOnly = new Date(yyyy, mm - 1, dd);
        const today = new Date();
        const todayOnly = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
        );
        if (todayOnly <= endDateOnly) return false;

        this.showApplicantMessage = true;
        this.showApplicantMessageHeader = "Admission Closed";
        this.showApplicantMessageData = `Admissions for this batch closed on ${schedule.admission_end_date_ind_format}.\nPlease contact your student counselor for further assistance.`;
        return true;
      } catch (error) {
        console.error("Error fetching program schedule:", error);
        return false;
      }
    },
    async getApplicantDetail() {
      this.loading = true;
      this.form.deb_id = this.form.deb_id ?? "invalid";
      try {
        const response = await this.$axios.get(
          `/applicant_validate/${this.form.deb_id}/${this.form.dob}/${this.form.application_id}`,
        );
        this.proceedDialog = false;
        const data = response.data.data;
        this.applicantData = { ...data };
        const status = data.application_status;
        const messages = {
          Submitted: {
            header: "Application Under Review",
            text: "Thank you for submitting your application. It is currently under review by our team. We appreciate your patience and will notify you as soon as the review process is complete.",
          },
          "Re-Submitted": {
            header: "Application Under Review",
            text: "Thank you for resubmitting your application. It is currently under review by our team. We appreciate your patience and will notify you as soon as the review process is complete.",
          },
          Rejected: {
            header: "Application Rejected",
            text: `Your application has been rejected.\nRejection Reason: ${data.rejection_reason}`,
          },
          Admitted: {
            header: "Payment Completed",
            text: "Your payment has been successfully completed. Please check your email for further updates regarding your application status.",
          },
        };

        if (status !== "Pending") {
          this.loading = false;

          if (messages[status]) {
            this.showApplicantMessage = true;
            this.showApplicantMessageHeader = messages[status].header;
            this.showApplicantMessageData = messages[status].text;
            return;
          }

          if (["Approved", "Provisionally Approved"].includes(status)) {
            this.showPayment(data);
            return;
          }

          this.showApplicantMessage = false;
        }

        this.loading = false;
        if (data.initial_deb) {
          if (!data?.deb_validated) {
            this.confirmationText =
              "Entered DEB ID could not be validated. Are you sure you want to proceed?";
            this.confirmationDialog = true;
            return;
          } else if (data?.deb_invalid) {
            this.confirmationText =
              "Invalid DebId entered, Are you sure you want to proceed?";
            this.confirmationDialog = true;
            return;
          } else {
            this.setLocalStorageDetails(data);
            this.$router.push("/register");
            return;
          }
        } else {
          this.setLocalStorageDetails(data);
          this.$router.push("/register");
          return;
        }
      } catch (error) {
        this.loading = false;

        let errorMessage = await this.$store.dispatch(
          "throwError",
          error.response,
        );

        if (errorMessage === "Deb already exists") {
          errorMessage = "Please contact your student counselor.";
        }

        this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
      }
    },
    async approveUnIdentifiedDebApplicant() {
      const formData = new FormData();
      formData.append("attrs", JSON.stringify(this.applicantData));

      const response = await this.$axios.put(
        `/update_applicant/${this.applicantData.id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      const data = response.data.data;
      this.setLocalStorageDetails(data);
      this.$router.push("/register");
    },
    setLocalStorageDetails(data) {
      localStorage.setItem("debId", this.form.deb_id);
      localStorage.setItem("applicationId", this.form.application_id);
      localStorage.setItem("dob", this.form.dob);
      localStorage.setItem("applicantId", data.id);
    },
    async proceed() {
      if (this.form.has_deb_id === "false") {
        this.form.deb_id = "invalid";
      }
      if (!this.$refs.debValidate.validate()) {
        return;
      }
      await this.getApplicantDetail();
    },
    resetValues() {
      this.$refs.form.reset();
    },
    async showPayment(item) {
      if (item.usn_id) {
        this.loading = false;
        this.showApplicantMessage = true;
        this.showApplicantMessageHeader = "Payment Completed";
        this.showApplicantMessageData =
          "Your payment has been successfully completed. Please check your email for further updates regarding your application status.";
        return;
      }
      const partner = await this.$axios.get(
        `/partners/get_by_code/${item.partner_code}`,
      );
      if (partner.data.data.partner_payment_required) {
        this.loading = false;
        this.showApplicantMessage = true;
        this.showApplicantMessageHeader = "";
        this.showApplicantMessageData = `Your application has been ${item.application_status.toLowerCase()}. Please contact the student counselor for further assistance.`;
        return;
      }
      this.loading = false;

      this.$router.push({
        path: "payment-options",
        name: "Payment Options",
        query: { id: item.id },
      });
    },
    registrationPage() {
      return this.$router.push("/registration");
    },
  },
};
</script>
